import { defineMessages } from 'react-intl'

export default defineMessages({
  viewAll: {
    id: 'attractions.viewAll',
    defaultMessage: 'View all',
  },
})
